<template>
  <VModal :disable-backdrop-click="false" @close="$emit('close')">
    <template #default="modalProps">
      <div class="max-w-5xl w-full mx-auto">
        <BaseCard>
          <BaseCardHeader>
            <div class="flex items-start justify-between">
              <h2 class="text-lg font-medium text-gray-900" id="slide-over-title">
                {{ $t('importContactsModal.title') }}
              </h2>
              <div class="ml-3 -mr-2 flex h-7 items-center">
                <button
                  type="button"
                  class="p-2 rounded-full bg-white text-gray-400 hover:text-gray-600 focus:outline-none focus:bg-gray-100"
                  @click="modalProps.close"
                >
                  <span class="sr-only">{{ $t('global.closeDialog') }}</span>
                  <!-- Heroicon name: outline/x -->
                  <svg
                    class="h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </BaseCardHeader>
          <ParseForm v-if="currentStep === 'parse'" @parsed="handleParsed" />
          <ProcessForm
            v-else-if="currentStep === 'process'"
            :account-id="accountId"
            :upload-id="parseData.uploadId"
            v-bind="parseData.data"
            @started="handleImportStarted"
          />
          <ImportStarted v-else-if="currentStep === 'started'" />
        </BaseCard>
      </div>
    </template>
  </VModal>
</template>

<script>
import ParseForm from './importContactsDialog/ParseForm.vue';
import ProcessForm from './importContactsDialog/ProcessForm.vue';
import ImportStarted from './importContactsDialog/ImportStarted.vue';

export default {
  name: 'ImportContactsDialog',
  components: {
    ParseForm,
    ProcessForm,
    ImportStarted,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      currentStep: 'parse',
      parseData: null,
    };
  },
  methods: {
    handleParsed(parseData) {
      this.parseData = parseData;
      this.currentStep = 'process';
    },
    handleImportStarted() {
      this.currentStep = 'started';
    },
  },
};
</script>
